export const ACTIONS = {
  STATUS: 'loader/main_loading_status',
};

export const mainStatusLoading = status => dispatch => dispatch({ type: ACTIONS.STATUS, payload: status });
